module.exports = __webpack_public_path__ + "static/UnclickPersonalAccidentYellow-147f0deea9903239074f1a9b5d84de7f.png";